import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { getApiUrl } from "../../config";

export default function ButtonsTab() {
  const [loading, setLoading] = useState<string | null>(null);
  const [result, setResult] = useState<{ type: "success" | "error"; message: string } | null>(null);

  const handleTest = async (endpoint: string, label: string) => {
    setLoading(label);
    setResult(null);
    try {
      const res = await fetch(getApiUrl(endpoint), { method: "POST", credentials: "include" });
      const data = await res.json();
      if (!res.ok) {
        setResult({ type: "error", message: data.message || `Failed: ${res.status}` });
      } else {
        setResult({ type: "success", message: data.message || "Success" });
      }
    } catch (e) {
      setResult({ type: "error", message: e instanceof Error ? e.message : "Request failed" });
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 py-8">
      <div className="flex flex-wrap gap-4">
        <Button
          onClick={() => handleTest("/api/test/sms", "sms")}
          disabled={loading !== null}
        >
          {loading === "sms" && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Test SMS
        </Button>
        <Button
          onClick={() => handleTest("/api/test/bucket", "bucket")}
          disabled={loading !== null}
        >
          {loading === "bucket" && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Test S3 Bucket
        </Button>
      </div>
      {result && (
        <p className={result.type === "success" ? "text-success" : "text-destructive"}>
          {result.message}
        </p>
      )}
    </div>
  );
} 
